import os from "os";

import { Logger } from "@skbkontur/logger";

const logger = Logger.create({
    identity: `my-app.${os.hostname()}`,
    loggerIndexPrefix: "candy-tools",
    loggerApiKey: "candy-tools-VaeNg1waeth7fuv5Jeizeib5eorieng4",
    loggerServerName: "https://elk-relay6.skbkontur.ru",
    allowedMetaFields: ["stackTrace", "dev"],
});

const dev: boolean = process.argv.includes("--development-mode");

function ignoreError(context: unknown): boolean {
    if (typeof context !== "object" || context == undefined) {
        return false;
    }

    if (
        // @ts-ignore
        typeof context.stackTrace === "string" &&
        // @ts-ignore
        context.stackTrace.startsWith("Error: listen EADDRINUSE: address already in use :::9080")
    ) {
        // eslint-disable-next-line no-console
        console.error("Port 9080 is already use, maybe local-server run.");
        // @ts-ignore
        // eslint-disable-next-line no-console
        console.error(context.stackTrace);
        return true;
    }

    return false;
}

// Пока в тестовом режиме, будем смотреть, что вообще ловится
export const ELKLogger = {
    error: (error: string, context: unknown): void => {
        if (ignoreError(context)) {
            process.exit(-1);
        }
        // @ts-ignore
        const contextObject: object = { ...context };
        logger.error(error, { ...contextObject, dev: dev });
        // process.exit прерывает запрос
        setTimeout(() => process.exit(-1), 1000);
    },
};
